import React from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CheckBoxTwoToneIcon from '@material-ui/icons/CheckBoxTwoTone';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import BackButton from '../../components/backButton/backButton';

import './createOrderSuccess.less';

const RegistrationSuccess = ({ history }) => (
  <Container className="create-order-success-page page-container">
    <BackButton to="/" />
    <div className="title-wrapper">
      <Typography variant="h3">
        Twoje zamówienie
      </Typography>
    </div>

    <Paper className="paper-box">
      <Container>
        <div className="row">
          <div className="icon-wrapper">
            <CheckBoxTwoToneIcon color="primary" />
          </div>
          <div>
            <Typography className="paper-title" variant="h5">
              Dziękujemy za złożenie zamówienia!
            </Typography>
            <Typography variant="body1">
              Przyjęliśmy Twoje zamówienie do realizacji.
            </Typography>
          </div>
        </div>
      </Container>
    </Paper>

    <div className="ok-button-container">
      <Button size="large" variant="contained" color="primary" type="submit" onClick={() => history.replace('/')}>
        OK
      </Button>
    </div>
  </Container>
);

RegistrationSuccess.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
};

export default withRouter(RegistrationSuccess);
